module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sign-up-sub-about",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": "Signup & Rules"
    }
  }), _vm._v(" "), _c('div-container', [_c('div-columns', {
    attrs: {
      "paddingTop": "1rem",
      "paddingBottom": "0px"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "0",
      "padding-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.paragraph1.title))])]), _vm._v(" "), (_vm.imageUrl) ? _c('div-columns', {
    attrs: {
      "paddingTop": "1em"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "1em"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph1.content)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('h4', {
    staticClass: "button is-primary",
    class: [(_vm.isSignUpTeam ? '' : 'button-disabled')],
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "disabled": !_vm.isSignUpTeam
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.isSignUpTeam ? '/signup?type=team' : ''
    },
    on: {
      "click": function($event) {
        _vm.isSignUpTeam ? function () {} : $event.preventDefault()
      }
    }
  }, [_vm._v("\n            Team Application\n          ")]), _vm._v(" "), (_vm.teamDisabledText && _vm.isSignUpTeamUi) ? _c('div', {
    staticClass: "text-tilted"
  }, [_c('h4', {
    staticStyle: {
      "color": "#390e07"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.teamDisabledText)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "button is-primary",
    class: [(_vm.isSignUpJudge ? '' : 'button-disabled')],
    staticStyle: {
      "margin": "10px",
      "position": "relative"
    },
    attrs: {
      "disabled": !_vm.isSignUpJudge
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.isSignUpJudge ? '/signup?type=judge' : ''
    },
    on: {
      "click": function($event) {
        _vm.isSignUpJudge ? function () {} : $event.preventDefault()
      }
    }
  }, [_vm._v("\n            Judge Application\n          ")]), _vm._v(" "), (_vm.judgeDisabledText && _vm.isSignUpJudgeUi) ? _c('div', {
    staticClass: "text-tilted"
  }, [_c('h4', {
    staticStyle: {
      "color": "#390e07"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.judgeDisabledText)
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div-columns', {
    attrs: {
      "paddingTop": "0px",
      "paddingBottom": "0px"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.paragraph2.title))])]), _vm._v(" "), (_vm.imageUrl) ? _c('div-columns', {
    attrs: {
      "paddingTop": "0.5em"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "0.5em"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph2.content)
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0ff3b72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutSignUpSubSection.vue
// module id = 931
// module chunks = 1